<main id="project_institutional">
  <!-- <app-navbar></app-navbar> -->

  <section id="page_main">
    <div class="institutional_container">
      <h1 class="title_Institutional">Institucional</h1>

      <div>
        <div class="institutional_concept">
          <div class="about_institutional">
            <h1 class="title-blue">Conceito<br />Jurídico</h1>

            <div>
              <p class="text_about_institutional">
                Fundação é uma pessoa jurídica de direito privado sem fins lucrativos, constituída pela destinação de um
                patrimônio para a execução de determinados fins.
              </p>

              <p class="text_about_institutional">
                O seu instituidor, que pode ser uma pessoa física ou pessoa jurídica, estabelece a sua criação mediante
                dotação de bens e declaração de fins.
              </p>

              <p class="text_about_institutional">
                Para ser atribuída personalidade jurídica à fundação, é preciso ainda a declaração do seu modo de
                funcionamento e a aprovação do estatuto pelo Ministério Público.
              </p>

              <p class="text_about_institutional">
                Os fins a que visam tais entidades devem ser necessariamente de natureza altruística, ora estimulando a
                cultura e investigação científica, artística e literária, ora realizando finalidades filantrópicas.
              </p>

              <p class="text_about_institutional">
                A missão da FPLF é promover serviços e gestão de projetos e programas de interesse da sociedade, em
                sintonia com os propósitos institucionais da PUC-Rio, através de convênios e contratos que objetivam o
                desenvolvimento e a prestação de serviços de caráter técnico, científico, cultural, social e artístico.
              </p>
            </div>
          </div>

            <img
              id="img_institutional"
              src="../../../assets/imagens/Group 166@2x.png"
              alt=""
            />

        </div>
      </div>
    </div>
  </section>

  <section id="second_page">
    <h1 class="title-blue">Ata de<br />Constituição</h1>

    <div class="minutes_institution">
      <div class="side">
        <p *ngFor="let item of minutes_institutional[0]" [innerHTML]="item"></p>
      </div>
      <div class="side">
        <p *ngFor="let item of minutes_institutional[1]" [innerHTML]="item"></p>
      </div>
    </div>
  </section>

  <section id="third_page">
    <div class="institutional_concept">
      <div class="instalations">
        <h1 class="title-blue">Instalações</h1>

        <div>
          <p class="text_instalations">
            A estrutura técnico administrativa da FPLF se organiza no edifício
            Padre Leonel Franca, situado no Campus da PUC-Rio, no bairro da
            Gávea, na cidade do Rio de Janeiro.
          </p>

          <p class="text_instalations">
            A partir deste local privilegiado, no centro do Campus, a FPLF
            articula a infraestrutura de um moderno parque tecnológico da
            PUC-Rio, que inclui laboratórios de pesquisa em diferentes áreas de
            conhecimento e a excelência de pesquisadores, mestres e doutores da
            Universidade, para executar projetos de relevante colaboração para a
            sociedade.
          </p>

          <p class="text_instalations">
            Sua infraestrutura permite ainda fomentar a realização destes
            projetos.
          </p>
        </div>
      </div>
      <div class="squared_instalations">
        <div class="img_grid">
          <img
            class="img img_1"
            src="../../../assets/imagens/instalations_grid1.png"
            alt=""
          />
          <img
            class="img img_2"
            src="../../../assets/imagens/instalations_grid2.png"
            alt=""
          />
          <img
            class="img img_3"
            src="../../../assets/imagens/instalations_grid3.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
  <!-- <footer class="footer">
    <app-footer></app-footer>
  </footer> -->
</main>
